import { useContext } from 'react';
import type { User } from '@supabase/supabase-js';
import type { Role } from '../types/auth';
import { AuthContext } from './AuthContext';

export interface AuthContextType {
  user: User | null;
  role: Role | null;
  permissions: string[];
  loading: boolean;
  signIn: (email: string, password: string) => Promise<void>;
  signUp: (
    firstName: string,
    email: string,
    password: string,
    notificationAccepted?: boolean,
    newsletterAccepted?: boolean,
    emailRedirectTo?: string
  ) => Promise<{ isConfirmed: boolean; email: string | undefined }>;
  signOut: () => Promise<void>;
  resetPassword: (email: string) => Promise<void>;
  updatePassword: (
    currentPassword: string,
    newPassword: string,
    email: string
  ) => Promise<string | undefined>;
  updateResetPassword: (password: string) => Promise<void>;
  hasProfile: boolean;
  resendConfirmationEmail: (email?: string) => Promise<void>;
  hasPermission: (permission: string) => boolean;
  hasRole: (role: Role) => boolean;
  updateEmail: (email: string) => Promise<void>;
  doesEmailExist: (email: string) => Promise<boolean>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
